import {Modal} from "@mui/material"
import {styled} from "@mui/material/styles"
import {breakpoints} from "@next/ux-fabric"

/*
 * Title: Using to style top !important
 * problem: we do not want to use !important but we want a modal and a modal is expected to cover the entire screen
 * in this case however, material UI probably assumes you'll have the entire screen covered and uses inline styles
 * to define this behaviour. But here the modal as it is the case of next, partially exposes the header area hence it
 * does not fully cover the entire screen.
 * Solution: for now we have to use !important
 * Refs:
 *    https://github.com/mui-org/material-ui/issues/16441
 *    https://github.com/mui-org/material-ui/issues/16442
 */

export const Container = styled(Modal)`
    && {
        transition: opacity 0.2s ease;
        animation-delay: 250ms;
        display: flex;
        justify-content: center;
        position: relative !important;
        height: 100vh;

        & > div:first-of-type {
            position: absolute;
            background: ${({theme}) => theme.uxfabric.components.backdrop.default.backgroundColor};
            z-index: 1;
        }
        & > [data-test="sentinelStart"] {
            display: none;
        }
        & > [data-test="sentinelEnd"] {
            display: none;
        }
    }
`

export const InnerContainer = styled("div")`
    width: 100%;
    height: fit-content;
    z-index: 2;
    outline: none;
    background: ${({theme}) => theme.uxfabric.components.menu.megaMenu.gutter.backgroundColor};

    &[data-focus-visible-added]:focus {
        outline: none;
    }

    @media (min-width: ${breakpoints.values.xs}px) and (max-width: ${breakpoints.values.lg}px) {
        height: 100%;
    }
    @media (min-width: ${breakpoints.values.lg}px) {
        display: table;
    }
`
